// extracted by mini-css-extract-plugin
export default {"ErrorBlock":"error-block_ErrorBlock__xOky3","MessageBlock":"error-block_MessageBlock__xBjD5"};